import { Button } from './Button'

export function LoadingState({ label = 'Caricamento dati' }: { label?: string }) {
  return (
    <div className="state state--loading" role="status">
      <span className="state__core" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  )
}

export function EmptyState({
  title,
  message,
}: {
  title: string
  message: string
}) {
  return (
    <div className="state">
      <span className="state__code">00</span>
      <h2>{title}</h2>
      <p>{message}</p>
    </div>
  )
}

export function ErrorState({
  title = 'Connessione interrotta',
  message = 'I dati TNTWars non sono disponibili in questo momento.',
  onRetry,
}: {
  title?: string
  message?: string
  onRetry?: () => void
}) {
  return (
    <div className="state state--error" role="alert">
      <span className="state__code">ERR</span>
      <h2>{title}</h2>
      <p>{message}</p>
      {onRetry ? (
        <Button onClick={onRetry} type="button">
          Riprova
        </Button>
      ) : null}
    </div>
  )
}
